import React from "react";
import discord from "../../images/integrations/discord.svg";
import IntegrationBot from "../../components/integrations/indegrations";

export default () => <IntegrationBot botLogo={discord} botName={"Discord"} />;
